import { CIcon } from '~/icons/types'

export const ciExchange: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M6.9 11.4c.1 0 .3 0 .4-.1.2-.2.2-.5 0-.7L4.2 7.4h14c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-14l3.1-3.1c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-4 4s-.1.1-.1.2v.4c0 .1.1.1.1.2l3.9 3.9c.2 0 .3.1.4.1Zm14.6 5.498c0-.1-.1-.1-.1-.2l-3.9-3.9c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l3.1 3.1h-14c-.3 0-.5.2-.5.5s.2.5.5.5h14l-3.1 3.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1s.3 0 .4-.1l3.9-3.9s.1-.1.1-.2v-.2c-.1-.1-.1-.2-.1-.2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'exchange',
  type: 'thin'
}
